import { render, staticRenderFns } from "./SaleReturnDetailQuery.vue?vue&type=template&id=42c43470&scoped=true"
import script from "./SaleReturnDetailQuery.vue?vue&type=script&lang=js"
export * from "./SaleReturnDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./SaleReturnDetailQuery.vue?vue&type=style&index=0&id=42c43470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c43470",
  null
  
)

export default component.exports